import { render, staticRenderFns } from "./IconLarge.vue?vue&type=template&id=6995442d&scoped=true&"
import script from "./IconLarge.vue?vue&type=script&lang=js&"
export * from "./IconLarge.vue?vue&type=script&lang=js&"
import style0 from "./IconLarge.vue?vue&type=style&index=0&id=6995442d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995442d",
  null
  
)

export default component.exports